import { render, staticRenderFns } from "./UpdateRewardModal.vue?vue&type=template&id=4d8c4d0f&scoped=true&"
import script from "./UpdateRewardModal.vue?vue&type=script&lang=js&"
export * from "./UpdateRewardModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRewardModal.vue?vue&type=style&index=0&id=4d8c4d0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8c4d0f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
